import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import ChartCard from '../Dashboard/ChartCard';
import { TopPerformersDto } from '../../services/learning/QuizReportService';

interface ParticipantRankingChartProps {
  data: TopPerformersDto[];
  title?: string;
  subtitle?: string;
  limit?: number;
}

const ParticipantRankingChart: React.FC<ParticipantRankingChartProps> = ({ 
  data, 
  title = 'Ranking de Participantes',
  subtitle,
  limit = 10
}) => {
  const chartData = data
    .slice(0, limit)
    .map(participant => ({
      name: participant.userName.length > 20 
        ? participant.userName.substring(0, 20) + '...' 
        : participant.userName,
      fullName: participant.userName,
      media: parseFloat((participant.averageScore || 0).toFixed(1)),
      melhorNota: parseFloat((participant.bestScore || 0).toFixed(1)),
      aprovados: participant.totalQuizzesPassed,
      totalTentativas: participant.totalAttempts,
    }))
    .reverse(); // Inverter para mostrar o melhor no topo

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div style={{
          background: 'rgba(44, 62, 80, 0.95)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '8px',
          padding: '12px',
          color: '#fff',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
        }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: 600 }}>{data.fullName}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} style={{ margin: '4px 0', color: entry.color }}>
              {entry.name}: {entry.value}{entry.name.includes('Média') || entry.name.includes('Melhor') ? '%' : ''}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  if (chartData.length === 0) {
    return (
      <ChartCard title={title} subtitle={subtitle}>
        <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
          Nenhum dado disponível para exibir
        </div>
      </ChartCard>
    );
  }

  return (
    <ChartCard title={title} subtitle={subtitle}>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart 
          data={chartData} 
          layout="vertical"
          margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(0, 0, 0, 0.1)" />
          <XAxis 
            type="number"
            domain={[0, 100]}
            tick={{ fill: '#666' }}
            label={{ value: 'Nota (%)', position: 'insideBottom', offset: -5 }}
          />
          <YAxis 
            type="category"
            dataKey="name"
            width={90}
            tick={{ fill: '#666', fontSize: 12 }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar 
            dataKey="media" 
            fill="#3498db" 
            name="Média de Notas (%)" 
            radius={[0, 4, 4, 0]} 
          />
          <Bar 
            dataKey="melhorNota" 
            fill="#f39c12" 
            name="Melhor Nota (%)" 
            radius={[0, 4, 4, 0]} 
          />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default ParticipantRankingChart;

